import React from "react";

export default function OpenIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      id="menuicon"
      className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="5" x2="19" y1="9" y2="9"></line>
      <line x1="5" x2="19" y1="15" y2="15"></line>
    </svg>
  );
}
